import React from 'react';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <div className="footer-left">
          <div className="footer-brand">Moro</div>
          <div className="footer-tag">One small task daily—feel better tomorrow.</div>
        </div>
        <div className="footer-right">
          <div className="footer-legal-title">Legal</div>
          <nav className="footer-legal">
            <a href="/privacy.html">Privacy Policy</a>
            <a href="/terms.html">Terms & Conditions</a>
          </nav>
          <div className="footer-copy">© {year} Moro · All rights reserved.</div>
        </div>
      </div>
    </footer>
  );
}